import AccountManagerDetails from './AccountManagerDetails';

export default AccountManagerDetails;
